"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteVariableCreated = exports.ShowVariableCreated = void 0;
var site_variable_message_1 = require("./site-variable-message");
Object.defineProperty(exports, "ShowVariableCreated", { enumerable: true, get: function () { return site_variable_message_1.ShowVariableCreated; } });
Object.defineProperty(exports, "SiteVariableCreated", { enumerable: true, get: function () { return site_variable_message_1.SiteVariableCreated; } });
